/**
 * Home-page "reassurances" content (the three-tile band under the
 * hero). Local for the same reasons as plans.js. easy to read,
 * version, and tweak without Strapi. Shape mirrors the previous
 * `data?.reassurances` GraphQL response so the Reassurances.vue
 * component template stays simple.
 *
 * Option A copy (2026-05-14): three brand pillars (privacy, agency,
 * delivery). Each tile maps to a load-bearing promise. Icons are
 * inline Material-style SVGs rendered by the component (no PNG
 * assets needed).
 *
 * Locale-keyed at the top. Add a new locale by copying a block.
 */

const enUS = {
  title: 'Three promises.',
  description: '',
  items: [
    {
      icon: 'favorite',
      title: 'Take care',
      description: 'Your circle deserves attention.',
    },
    {
      icon: 'bedtime',
      title: 'Privacy',
      description: 'Your wishes are yours, sealed and private.',
    },
    {
      icon: 'verified',
      title: 'Trust',
      description: 'We will keep our promise.\nFor sure 🕶️.',
    },
  ],
}

const frFR = {
  title: 'Trois engagements.',
  description: '',
  items: [
    {
      icon: 'favorite',
      title: 'Bienveillance',
      description: "Votre entourage mérite d'être choyé.",
    },
    {
      icon: 'bedtime',
      title: 'Discrétion',
      description: 'Vos souhaits sont les vôtres, scellés et privés.',
    },
    {
      icon: 'verified',
      title: 'Confiance',
      description: 'Nous tiendrons notre promesse.\nFor sure 🕶️.',
    },
  ],
}

export const reassurancesContent = {
  'en-US': enUS,
  'fr-FR': frFR,
}

/**
 * Picks the right slice for the active locale. Falls back to en-US
 * if the language is unset or unknown.
 */
export function getReassurancesContent(language) {
  return reassurancesContent[language] || reassurancesContent['en-US']
}
